import * as React from "react";
import { Handle, Position } from "@xyflow/react";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";

const FLOW_HANDLE_CLASS = "!size-2.5 !border-2 !border-background !bg-primary";

export function LeftTargetHandle() {
  return <Handle type="target" position={Position.Left} className={FLOW_HANDLE_CLASS} />;
}

export function RightSourceHandle() {
  return <Handle type="source" position={Position.Right} className={FLOW_HANDLE_CLASS} />;
}

interface FlowNodeCardProps {
  title: string;
  className?: string;
  rightSlot?: React.ReactNode;
  children: React.ReactNode;
}

export function FlowNodeCard({ title, className, rightSlot, children }: FlowNodeCardProps) {
  return (
    <Card className={cn("w-[260px] border-border/80 bg-card shadow-sm", className)}>
      <CardHeader className="space-y-0 px-3 py-2">
        <div className="flex items-center justify-between gap-2">
          <CardTitle className="text-[10px] font-semibold tracking-[0.08em] text-muted-foreground uppercase">
            {title}
          </CardTitle>
          {rightSlot}
        </div>
      </CardHeader>
      <CardContent className="space-y-1 px-3 pb-3 text-xs leading-5">{children}</CardContent>
    </Card>
  );
}

interface FlowNodeRowProps {
  label: string;
  value: React.ReactNode;
  valueClassName?: string;
}

export function FlowNodeRow({ label, value, valueClassName }: FlowNodeRowProps) {
  return (
    <div className="flex items-start justify-between gap-3">
      <span className="text-muted-foreground">{label}</span>
      <span className={cn("min-w-0 text-right font-medium", valueClassName)}>{value}</span>
    </div>
  );
}
